import { useLayoutEffect, useRef } from 'react';

function ScrollTo() {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      ref.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }, []);

  return <div ref={ref} />;
}

export default ScrollTo;
